<template>
  <div class="geo-table-wrap">
    <div v-if="model && !!models[model] || !!models[model.replace('e-', '')]" class="flex">
      <div class="geometryWrap">
        <img
          id="fixLine"
          ref="image-map"
          :src="models[model.replace('e-', '')].images"
          alt="Geometry"
          style="max-width: 100%;"
          usemap="#frame-map"
        />

        <siryon v-if="model==='e-siryon' || model==='siryon'" :letter="currentLetter"/>
        <cyon v-if="model==='e-cyon' || model==='cyon'" :letter="currentLetter"/>
        <aryon v-if="model==='aryon'" :letter="currentLetter"/>
        <aryonSC v-if="model==='aryon-sc'" :letter="currentLetter"/>
        <hydraHalo v-if="model==='hydraHalo' || model==='e-hydraHalo'" :letter="currentLetter"/>
        <hydraDiode v-if="model==='hydraDiode' || model==='e-hydraDiode'" :letter="currentLetter"/>
        <cygnusMusc v-if="model === 'cygnus.muscular'" :letter="currentLetter" />
        <cygnusEbike v-if="model==='cygnus' || model==='e-cygnus'" :letter="currentLetter" />
        <siryonMusc v-if="model==='siryon.muscular'" :letter="currentLetter"/>
        <map
          v-if="!!models[model]"
          name="frame-map">
          <area
            v-for="(item, index) in models[model].items"
            :key="index"
            :coords="item.cords"
            :shape="item.shape"
            :title="item.letter"
            href="#"
            target="_self"
            @mouseover="switchTable($event, item.letter)"
            @click.prevent="switchTable($event, item.letter)"
          >
        </map>

      </div>
      <table v-if="model==='e-siryon' || model==='siryon'" :class="sizeClass" cellpadding="0" cellspacing="0" class="geoTable">
        <thead>
        <tr>
          <th></th>
          <th></th>
          <th>S</th>
          <th>M</th>
          <th>L</th>
          <th>XL</th>
        </tr>
        </thead>
        <tbody>
        <tr
          :class="{ active: isLetterActive('a') }"
          @mouseover="switchTable($event, 'a')"
        >
          <td>A</td>
          <td>{{ trans['top_tube'] }}</td>
          <td><span class="size">579</span><span class="mm">mm</span></td>
          <td><span class="size">609</span><span class="mm">mm</span></td>
          <td><span class="size">648</span><span class="mm">mm</span></td>
          <td><span class="size">673</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('b') }"
          @mouseover="switchTable($event, 'b')"
        >
          <td>B</td>
          <td>{{ trans['reach'] }}</td>
          <td><span class="size">428</span><span class="mm">mm</span></td>
          <td><span class="size">458</span><span class="mm">mm</span></td>
          <td><span class="size">488</span><span class="mm">mm</span></td>
          <td><span class="size">508</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('c') }"
          @mouseover="switchTable($event, 'c')"
        >
          <td>C</td>
          <td>{{ trans.stack }}</td>
          <td><span class="size">612</span><span class="mm">mm</span></td>
          <td><span class="size">612</span><span class="mm">mm</span></td>
          <td><span class="size">625</span><span class="mm">mm</span></td>
          <td><span class="size">639</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('d') }"
          @mouseover="switchTable($event, 'd')"
        >
          <td>D</td>
          <td>{{ trans['seat_tube_length'] }}</td>
          <td><span class="size">420</span><span class="mm">mm</span></td>
          <td><span class="size">430</span><span class="mm">mm</span></td>
          <td><span class="size">465</span><span class="mm">mm</span></td>
          <td><span class="size">500</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('e') }"
          @mouseover="switchTable($event, 'e')"
        >
          <td>E</td>
          <td>{{ trans['chainstay_horizontal'] }}</td>
          <td><span class="size">436</span><span class="mm">mm</span></td>
          <td><span class="size">436</span><span class="mm">mm</span></td>
          <td><span class="size">446</span><span class="mm">mm</span></td>
          <td><span class="size">446</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('f') }"
          @mouseover="switchTable($event, 'f')"
        >
          <td>F</td>
          <td>{{ trans['head_tube_angle'] }}</td>
          <td>
            <span class="size">64 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">64 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">64 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">64 <sup>°</sup></span>
          </td>
        </tr>
        <tr
          :class="{ active: isLetterActive('g') }"
          @mouseover="switchTable($event, 'g')"
        >
          <td>G</td>
          <td>{{ trans['seat_tube_angle'] }}</td>
          <td>
            <span class="size">77 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">77 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">77 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">77 <sup>°</sup></span>
          </td>
        </tr>
        <tr
          :class="{ active: isLetterActive('h') }"
          @mouseover="switchTable($event, 'h')"
        >
          <td>H</td>
          <td>{{ trans['bb_drop'] }}</td>
          <td><span class="size">-25</span><span class="mm">mm</span></td>
          <td><span class="size">-25</span><span class="mm">mm</span></td>
          <td><span class="size">-25</span><span class="mm">mm</span></td>
          <td><span class="size">-25</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('i') }"
          @mouseover="switchTable($event, 'i')"
        >
          <td>I</td>
          <td>{{ trans['wheel_base'] }}</td>
          <td><span class="size">1208</span><span class="mm">mm</span></td>
          <td><span class="size">1238</span><span class="mm">mm</span></td>
          <td><span class="size">1284</span><span class="mm">mm</span></td>
          <td><span class="size">1311</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('j') }"
          @mouseover="switchTable($event, 'j')"
        >
          <td>J</td>
          <td>{{ trans['head_tube_length'] }}</td>
          <td><span class="size">95</span><span class="mm">mm</span></td>
          <td><span class="size">95</span><span class="mm">mm</span></td>
          <td><span class="size">110</span><span class="mm">mm</span></td>
          <td><span class="size">125</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('k') }"
          @mouseover="switchTable($event, 'k')"
        >
          <td>K</td>
          <td>{{ trans['bb_height'] }}</td>
          <td><span class="size">353</span><span class="mm">mm</span></td>
          <td><span class="size">353</span><span class="mm">mm</span></td>
          <td><span class="size">353</span><span class="mm">mm</span></td>
          <td><span class="size">353</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('l') }"
          @mouseover="switchTable($event, 'l')"
        >
          <td>L</td>
          <td>{{ trans['fork_offset'] }}</td>
          <td><span class="size">51</span><span class="mm">mm</span></td>
          <td><span class="size">51</span><span class="mm">mm</span></td>
          <td><span class="size">51</span><span class="mm">mm</span></td>
          <td><span class="size">51</span><span class="mm">mm</span></td>
        </tr>
        </tbody>
      </table>
      <table v-if="model==='e-cyon' || model==='cyon'" :class="sizeClass" cellpadding="0" cellspacing="0" class="geoTable">
        <thead>
        <tr>
          <th></th>
          <th></th>
          <th>S</th>
          <th>M</th>
          <th>L</th>
          <th>XL</th>
        </tr>
        </thead>
        <tbody>
        <tr
          :class="{ active: isLetterActive('a') }"
          @mouseover="switchTable($event, 'a')"
        >
          <td>A</td>
          <td>{{ trans['top_tube_horizontal'] }}</td>
          <td><span class="size">577</span><span class="mm">mm</span></td>
          <td><span class="size">603</span><span class="mm">mm</span></td>
          <td><span class="size">633</span><span class="mm">mm</span></td>
          <td><span class="size">657</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('b') }"
          @mouseover="switchTable($event, 'b')"
        >
          <td>B</td>
          <td>{{ trans['reach'] }}</td>
          <td><span class="size">430</span><span class="mm">mm</span></td>
          <td><span class="size">455</span><span class="mm">mm</span></td>
          <td><span class="size">480</span><span class="mm">mm</span></td>
          <td><span class="size">500</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('c') }"
          @mouseover="switchTable($event, 'c')"
        >
          <td>C</td>
          <td>{{ trans.stack }}</td>
          <td><span class="size">611</span><span class="mm">mm</span></td>
          <td><span class="size">616</span><span class="mm">mm</span></td>
          <td><span class="size">625</span><span class="mm">mm</span></td>
          <td><span class="size">638</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('d') }"
          @mouseover="switchTable($event, 'd')"
        >
          <td>D</td>
          <td>{{ trans['seat_tube_length'] }}</td>
          <td><span class="size">415</span><span class="mm">mm</span></td>
          <td><span class="size">430</span><span class="mm">mm</span></td>
          <td><span class="size">465</span><span class="mm">mm</span></td>
          <td><span class="size">500</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('e') }"
          @mouseover="switchTable($event, 'e')"
        >
          <td>E</td>
          <td>{{ trans["chainstay_horizontal"] }}</td>
          <td><span class="size">435</span><span class="mm">mm</span></td>
          <td><span class="size">435</span><span class="mm">mm</span></td>
          <td><span class="size">445</span><span class="mm">mm</span></td>
          <td><span class="size">445</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('f') }"
          @mouseover="switchTable($event, 'f')"
        >
          <td>F</td>
          <td>{{ trans['head_tube_angle'] }}</td>
          <td>
            <span class="size">65.5<sup>°</sup></span>
          </td>
          <td>
            <span class="size">65.5<sup>°</sup></span>
          </td>
          <td>
            <span class="size">65.5<sup>°</sup></span>
          </td>
          <td>
            <span class="size">65.5<sup>°</sup></span>
          </td>
        </tr>
        <tr
          :class="{ active: isLetterActive('g') }"
          @mouseover="switchTable($event, 'g')"
        >
          <td>G</td>
          <td>{{ trans['seat_tube_angle'] }}</td>
          <td>
            <span class="size">76.6<sup>°</sup></span>
          </td>
          <td>
            <span class="size">76.6<sup>°</sup></span>
          </td>
          <td>
            <span class="size">76.6<sup>°</sup></span>
          </td>
          <td>
            <span class="size">76.6<sup>°</sup></span>
          </td>
        </tr>
        <tr
          :class="{ active: isLetterActive('h') }"
          @mouseover="switchTable($event, 'h')"
        >
          <td>H</td>
          <td>{{ trans['bb_drop'] }}</td>
          <td><span class="size">-30</span><span class="mm">mm</span></td>
          <td><span class="size">-30</span><span class="mm">mm</span></td>
          <td><span class="size">-30</span><span class="mm">mm</span></td>
          <td><span class="size">-30</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('i') }"
          @mouseover="switchTable($event, 'i')"
        >
          <td>I</td>
          <td>{{ trans['wheel_base'] }}</td>
          <td><span class="size">1176</span><span class="mm">mm</span></td>
          <td><span class="size">1203</span><span class="mm">mm</span></td>
          <td><span class="size">1242</span><span class="mm">mm</span></td>
          <td><span class="size">1268</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('j') }"
          @mouseover="switchTable($event, 'j')"
        >
          <td>J</td>
          <td>{{ trans['head_tube_length'] }}</td>
          <td><span class="size">95</span><span class="mm">mm</span></td>
          <td><span class="size">100</span><span class="mm">mm</span></td>
          <td><span class="size">110</span><span class="mm">mm</span></td>
          <td><span class="size">125</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('k') }"
          @mouseover="switchTable($event, 'k')"
        >
          <td>K</td>
          <td>{{ trans['bb_height'] }}</td>
          <td><span class="size">346</span><span class="mm">mm</span></td>
          <td><span class="size">346</span><span class="mm">mm</span></td>
          <td><span class="size">346</span><span class="mm">mm</span></td>
          <td><span class="size">346</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('l') }"
          @mouseover="switchTable($event, 'l')"
        >
          <td>L</td>
          <td>{{ trans['fork_offset'] }}</td>
          <td><span class="size">42</span><span class="mm">mm</span></td>
          <td><span class="size">42</span><span class="mm">mm</span></td>
          <td><span class="size">42</span><span class="mm">mm</span></td>
          <td><span class="size">42</span><span class="mm">mm</span></td>
        </tr>
        </tbody>
      </table>
      <table v-if="model==='aryon'" :class="sizeClass" cellpadding="0" cellspacing="0" class="geoTable">
        <thead>
        <tr>
          <th></th>
          <th></th>
          <th>{{ trans['onesize'] }}</th>
        </tr>
        </thead>
        <tbody>
        <tr
          :class="{ active: isLetterActive('a') }"
          @mouseover="switchTable($event, 'a')"
        >
          <td>A</td>
          <td>{{ trans['top_tube'] }}</td>
          <td><span class="size">541</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('b') }"
          @mouseover="switchTable($event, 'b')"
        >
          <td>B</td>
          <td>{{ trans['reach'] }}</td>
          <td><span class="size">435</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('c') }"
          @mouseover="switchTable($event, 'c')"
        >
          <td>C</td>
          <td>{{ trans.stack }}</td>
          <td><span class="size">467</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('d') }"
          @mouseover="switchTable($event, 'd')"
        >
          <td>D</td>
          <td>{{ trans['seat_tube_length'] }}</td>
          <td><span class="size">425</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('e') }"
          @mouseover="switchTable($event, 'e')"
        >
          <td>E</td>
          <td>{{ trans['chainstay_horizontal'] }}</td>
          <td><span class="size">416</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('f') }"
          @mouseover="switchTable($event, 'f')"
        >
          <td>F</td>
          <td>{{ trans['head_tube_angle'] }}</td>
          <td>
            <span class="size">69 <sup>°</sup></span>
          </td>
        </tr>
        <tr
          :class="{ active: isLetterActive('g') }"
          @mouseover="switchTable($event, 'g')"
        >
          <td>G</td>
          <td>{{ trans['seat_tube_angle'] }}</td>
          <td>
            <span class="size">77 <sup>°</sup></span>
          </td>
        </tr>
        <tr
          :class="{ active: isLetterActive('h') }"
          @mouseover="switchTable($event, 'h')"
        >
          <td>H</td>
          <td>{{ trans['bb_drop'] }}</td>
          <td><span class="size">+40</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('i') }"
          @mouseover="switchTable($event, 'i')"
        >
          <td>I</td>
          <td>{{ trans['wheel_base'] }}</td>
          <td><span class="size">1095</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('j') }"
          @mouseover="switchTable($event, 'j')"
        >
          <td>J</td>
          <td>{{ trans['head_tube_length'] }}</td>
          <td><span class="size">125</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('k') }"
          @mouseover="switchTable($event, 'k')"
        >
          <td>K</td>
          <td>{{ trans['bb_height'] }}</td>
          <td><span class="size">306</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('l') }"
          @mouseover="switchTable($event, 'l')"
        >
          <td>L</td>
          <td>{{ trans['fork_offset'] }}</td>
          <td><span class="size">46</span><span class="mm">mm</span></td>
        </tr>
        </tbody>
      </table>
      <table v-if="model==='aryon-sc'" :class="sizeClass" cellpadding="0" cellspacing="0" class="geoTable">
        <thead>
        <tr>
          <th></th>
          <th></th>
          <th>{{ trans['onesize'] }}</th>
        </tr>
        </thead>
        <tbody>
        <tr
          :class="{ active: isLetterActive('a') }"
          @mouseover="switchTable($event, 'a')"
        >
          <td>A</td>
          <td>{{ trans['top_tube'] }}</td>
          <td><span class="size">577</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('b') }"
          @mouseover="switchTable($event, 'b')"
        >
          <td>B</td>
          <td>{{ trans['reach'] }}</td>
          <td><span class="size">435</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('c') }"
          @mouseover="switchTable($event, 'c')"
        >
          <td>C</td>
          <td>{{ trans.stack }}</td>
          <td><span class="size">467</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('d') }"
          @mouseover="switchTable($event, 'd')"
        >
          <td>D</td>
          <td>{{ trans['seat_tube_length'] }}</td>
          <td><span class="size">435</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('e') }"
          @mouseover="switchTable($event, 'e')"
        >
          <td>E</td>
          <td>{{ trans['chainstay_horizontal'] }}</td>
          <td><span class="size">415</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('f') }"
          @mouseover="switchTable($event, 'f')"
        >
          <td>F</td>
          <td>{{ trans['head_tube_angle'] }}</td>
          <td>
            <span class="size">69 <sup>°</sup></span>
          </td>
        </tr>
        <tr
          :class="{ active: isLetterActive('g') }"
          @mouseover="switchTable($event, 'g')"
        >
          <td>G</td>
          <td>{{ trans['seat_tube_angle'] }}</td>
          <td>
            <span class="size">73 <sup>°</sup></span>
          </td>
        </tr>
        <tr
          :class="{ active: isLetterActive('h') }"
          @mouseover="switchTable($event, 'h')"
        >
          <td>H</td>
          <td>{{ trans['bb_drop'] }}</td>
          <td><span class="size">+32</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('i') }"
          @mouseover="switchTable($event, 'i')"
        >
          <td>I</td>
          <td>{{ trans['wheel_base'] }}</td>
          <td><span class="size">1088</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('j') }"
          @mouseover="switchTable($event, 'j')"
        >
          <td>J</td>
          <td>{{ trans['head_tube_length'] }}</td>
          <td><span class="size">125</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('k') }"
          @mouseover="switchTable($event, 'k')"
        >
          <td>K</td>
          <td>{{ trans['bb_height'] }}</td>
          <td><span class="size">298</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('l') }"
          @mouseover="switchTable($event, 'l')"
        >
          <td>L</td>
          <td>{{ trans['fork_offset'] }}</td>
          <td><span class="size">43</span><span class="mm">mm</span></td>
        </tr>
        </tbody>
      </table>
      <table v-if="model==='e-hydraHalo' || model==='hydraHalo'" :class="sizeClass" cellpadding="0" cellspacing="0" class="geoTable">
        <thead>
        <tr>
          <th></th>
          <th></th>
          <th>S</th>
          <th>M</th>
          <th>L</th>
          <th>XL</th>
        </tr>
        </thead>
        <tbody>
        <tr
          :class="{ active: isLetterActive('a') }"
          @mouseover="switchTable($event, 'a')"
        >
          <td>A</td>
          <td>{{ trans['top_tube_horizontal'] }}</td>
          <td><span class="size">571</span><span class="mm">mm</span></td>
          <td><span class="size">603</span><span class="mm">mm</span></td>
          <td><span class="size">639</span><span class="mm">mm</span></td>
          <td><span class="size">660</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('b') }"
          @mouseover="switchTable($event, 'b')"
        >
          <td>B</td>
          <td>{{ trans['reach'] }}</td>
          <td><span class="size">418</span><span class="mm">mm</span></td>
          <td><span class="size">449</span><span class="mm">mm</span></td>
          <td><span class="size">479</span><span class="mm">mm</span></td>
          <td><span class="size">499</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('c') }"
          @mouseover="switchTable($event, 'c')"
        >
          <td>C</td>
          <td>{{ trans['stack'] }}</td>
          <td><span class="size">619</span><span class="mm">mm</span></td>
          <td><span class="size">619</span><span class="mm">mm</span></td>
          <td><span class="size">632</span><span class="mm">mm</span></td>
          <td><span class="size">646</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('d') }"
          @mouseover="switchTable($event, 'd')"
        >
          <td>D</td>
          <td>{{ trans['seat_tube_length'] }}</td>
          <td><span class="size">420</span><span class="mm">mm</span></td>
          <td><span class="size">430</span><span class="mm">mm</span></td>
          <td><span class="size">465</span><span class="mm">mm</span></td>
          <td><span class="size">500</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('e') }"
          @mouseover="switchTable($event, 'e')"
        >
          <td>E</td>
          <td>{{ trans['chainstay_horizontal'] }}</td>
          <td><span class="size">436</span><span class="mm">mm</span></td>
          <td><span class="size">436</span><span class="mm">mm</span></td>
          <td><span class="size">446</span><span class="mm">mm</span></td>
          <td><span class="size">446</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('f') }"
          @mouseover="switchTable($event, 'f')"
        >
          <td>F</td>
          <td>{{ trans['head_tube_angle'] }}</td>
          <td>
            <span class="size">63 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">63 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">63 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">63 <sup>°</sup></span>
          </td>
        </tr>
        <tr
          :class="{ active: isLetterActive('g') }"
          @mouseover="switchTable($event, 'g')"
        >
          <td>G</td>
          <td>{{ trans['seat_tube_angle'] }}</td>
          <td>
            <span class="size">76 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">76 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">76 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">76 <sup>°</sup></span>
          </td>
        </tr>
        <tr
          :class="{ active: isLetterActive('h') }"
          @mouseover="switchTable($event, 'h')"
        >
          <td>H</td>
          <td>{{ trans['bb_drop'] }}</td>
          <td><span class="size">-18</span><span class="mm">mm</span></td>
          <td><span class="size">-18</span><span class="mm">mm</span></td>
          <td><span class="size">-18</span><span class="mm">mm</span></td>
          <td><span class="size">-18</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('i') }"
          @mouseover="switchTable($event, 'i')"
        >
          <td>I</td>
          <td>{{ trans['wheel_base'] }}</td>
          <td><span class="size">1212</span><span class="mm">mm</span></td>
          <td><span class="size">1242</span><span class="mm">mm</span></td>
          <td><span class="size">1288</span><span class="mm">mm</span></td>
          <td><span class="size">1315</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('j') }"
          @mouseover="switchTable($event, 'j')"
        >
          <td>J</td>
          <td>{{ trans['head_tube_length'] }}</td>
          <td><span class="size">95</span><span class="mm">mm</span></td>
          <td><span class="size">95</span><span class="mm">mm</span></td>
          <td><span class="size">110</span><span class="mm">mm</span></td>
          <td><span class="size">125</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('k') }"
          @mouseover="switchTable($event, 'k')"
        >
          <td>K</td>
          <td>{{ trans['bb_height'] }}</td>
          <td><span class="size">360</span><span class="mm">mm</span></td>
          <td><span class="size">360</span><span class="mm">mm</span></td>
          <td><span class="size">360</span><span class="mm">mm</span></td>
          <td><span class="size">360</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('l') }"
          @mouseover="switchTable($event, 'l')"
        >
          <td>L</td>
          <td>{{ trans['fork_offset'] }}</td>
          <td><span class="size">46</span><span class="mm">mm</span></td>
          <td><span class="size">46</span><span class="mm">mm</span></td>
          <td><span class="size">46</span><span class="mm">mm</span></td>
          <td><span class="size">46</span><span class="mm">mm</span></td>
        </tr>
        </tbody>
      </table>
      <table v-if="model==='e-hydraDiode' || model==='hydraDiode'" :class="sizeClass" cellpadding="0" cellspacing="0" class="geoTable">
        <thead>
        <tr>
          <th></th>
          <th></th>
          <th>S</th>
          <th>M</th>
          <th>L</th>
          <th>XL</th>
        </tr>
        </thead>
        <tbody>
        <tr
          :class="{ active: isLetterActive('a') }"
          @mouseover="switchTable($event, 'a')"
        >
          <td>A</td>
          <td>{{ trans['top_tube_horizontal'] }}</td>
          <td><span class="size">572</span><span class="mm">mm</span></td>
          <td><span class="size">604</span><span class="mm">mm</span></td>
          <td><span class="size">639</span><span class="mm">mm</span></td>
          <td><span class="size">661</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('b') }"
          @mouseover="switchTable($event, 'b')"
        >
          <td>B</td>
          <td>{{ trans['reach'] }}</td>
          <td><span class="size">415</span><span class="mm">mm</span></td>
          <td><span class="size">446</span><span class="mm">mm</span></td>
          <td><span class="size">476</span><span class="mm">mm</span></td>
          <td><span class="size">496</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('c') }"
          @mouseover="switchTable($event, 'c')"
        >
          <td>C</td>
          <td>{{ trans.stack }}</td>
          <td><span class="size">621</span><span class="mm">mm</span></td>
          <td><span class="size">621</span><span class="mm">mm</span></td>
          <td><span class="size">634</span><span class="mm">mm</span></td>
          <td><span class="size">648</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('d') }"
          @mouseover="switchTable($event, 'd')"
        >
          <td>D</td>
          <td>{{ trans['seat_tube_length'] }}</td>
          <td><span class="size">420</span><span class="mm">mm</span></td>
          <td><span class="size">430</span><span class="mm">mm</span></td>
          <td><span class="size">465</span><span class="mm">mm</span></td>
          <td><span class="size">500</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('e') }"
          @mouseover="switchTable($event, 'e')"
        >
          <td>E</td>
          <td>{{ trans['chainstay_horizontal'] }}</td>
          <td><span class="size">436</span><span class="mm">mm</span></td>
          <td><span class="size">436</span><span class="mm">mm</span></td>
          <td><span class="size">446</span><span class="mm">mm</span></td>
          <td><span class="size">446</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('f') }"
          @mouseover="switchTable($event, 'f')"
        >
          <td>F</td>
          <td>{{ trans['head_tube_angle'] }}</td>
          <td>
            <span class="size">62.7 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">62.7 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">62.7 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">62.7 <sup>°</sup></span>
          </td>
        </tr>
        <tr
          :class="{ active: isLetterActive('g') }"
          @mouseover="switchTable($event, 'g')"
        >
          <td>G</td>
          <td>{{ trans['seat_tube_angle'] }}</td>
          <td>
            <span class="size">75.7 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">75.7 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">75.7 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">75.7 <sup>°</sup></span>
          </td>
        </tr>
        <tr
          :class="{ active: isLetterActive('h') }"
          @mouseover="switchTable($event, 'h')"
        >
          <td>H</td>
          <td>{{ trans['bb_drop'] }}</td>
          <td><span class="size">-16</span><span class="mm">mm</span></td>
          <td><span class="size">-16</span><span class="mm">mm</span></td>
          <td><span class="size">-16</span><span class="mm">mm</span></td>
          <td><span class="size">-16</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('i') }"
          @mouseover="switchTable($event, 'i')"
        >
          <td>I</td>
          <td>{{ trans['wheel_base'] }}</td>
          <td><span class="size">1216</span><span class="mm">mm</span></td>
          <td><span class="size">1245</span><span class="mm">mm</span></td>
          <td><span class="size">1292</span><span class="mm">mm</span></td>
          <td><span class="size">1318</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('j') }"
          @mouseover="switchTable($event, 'j')"
        >
          <td>J</td>
          <td>{{ trans['head_tube_length'] }}</td>
          <td><span class="size">95</span><span class="mm">mm</span></td>
          <td><span class="size">95</span><span class="mm">mm</span></td>
          <td><span class="size">110</span><span class="mm">mm</span></td>
          <td><span class="size">125</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('k') }"
          @mouseover="switchTable($event, 'k')"
        >
          <td>K</td>
          <td>{{ trans['bb_height'] }}</td>
          <td><span class="size">360</span><span class="mm">mm</span></td>
          <td><span class="size">360</span><span class="mm">mm</span></td>
          <td><span class="size">360</span><span class="mm">mm</span></td>
          <td><span class="size">360</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('l') }"
          @mouseover="switchTable($event, 'l')"
        >
          <td>L</td>
          <td>{{ trans['fork_offset'] }}</td>
          <td><span class="size">46</span><span class="mm">mm</span></td>
          <td><span class="size">46</span><span class="mm">mm</span></td>
          <td><span class="size">46</span><span class="mm">mm</span></td>
          <td><span class="size">46</span><span class="mm">mm</span></td>
        </tr>
        </tbody>
      </table>
      <!-- cygnusMusc -->
      <table v-if="model==='cygnus.muscular'" :class="sizeClass" cellpadding="0" cellspacing="0" class="geoTable">
        <thead>
        <tr>
          <th></th>
          <th></th>
          <th></th>
          <th>S/M</th>
          <th>L</th>
          <th>XL</th>
        </tr>
        </thead>
        <tbody>
        <tr
          :class="{ active: isLetterActive('a') }"
          @mouseover="switchTable($event, 'a')"
        >
          <td>A</td>
          <td>{{ trans['top_tube_horizontal'] }}</td>
          <td></td>
          <td><span class="size">595</span><span class="mm">mm</span></td>
          <td><span class="size">620</span><span class="mm">mm</span></td>
          <td><span class="size">650</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('b') }"
          @mouseover="switchTable($event, 'b')"
        >
          <td>B</td>
          <td>{{ trans['reach'] }}</td>
          <td></td>
          <td><span class="size">445</span><span class="mm">mm</span></td>
          <td><span class="size">470</span><span class="mm">mm</span></td>
          <td><span class="size">495</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('c') }"
          @mouseover="switchTable($event, 'c')"
        >
          <td>C</td>
          <td>{{ trans.stack }}</td>
          <td></td>
          <td><span class="size">602</span><span class="mm">mm</span></td>
          <td><span class="size">611</span><span class="mm">mm</span></td>
          <td><span class="size">625</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('d') }"
          @mouseover="switchTable($event, 'd')"
        >
          <td>D</td>
          <td>{{ trans['seat_tube_length'] }}</td>
          <td></td>
          <td><span class="size">415</span><span class="mm">mm</span></td>
          <td><span class="size">465</span><span class="mm">mm</span></td>
          <td><span class="size">500</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('e') }"
          @mouseover="switchTable($event, 'e')"
        >
          <td>E</td>
          <td>{{ trans['chainstay_horizontal'] }}</td>
          <td></td>
          <td><span class="size">435</span><span class="mm">mm</span></td>
          <td><span class="size">435</span><span class="mm">mm</span></td>
          <td><span class="size">435</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('f') }"
          @mouseover="switchTable($event, 'f')"
        >
          <td>F</td>
          <td>{{ trans['head_tube_angle'] }}</td>
          <td></td>
          <td>
            <span class="size">67 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">67 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">67 <sup>°</sup></span>
          </td>
        </tr>
        <tr
          :class="{ active: isLetterActive('g') }"
          @mouseover="switchTable($event, 'g')"
        >
          <td>G</td>
          <td>{{ trans['seat_tube_angle'] }}</td>
          <td></td>
          <td>
            <span class="size">75 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">75 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">75 <sup>°</sup></span>
          </td>
        </tr>
        <tr
          :class="{ active: isLetterActive('h') }"
          @mouseover="switchTable($event, 'h')"
        >
          <td>H</td>
          <td>{{ trans['bb_drop'] }}</td>
          <td></td>
          <td><span class="size">-36</span><span class="mm">mm</span></td>
          <td><span class="size">-36</span><span class="mm">mm</span></td>
          <td><span class="size">-36</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('i') }"
          @mouseover="switchTable($event, 'i')"
        >
          <td>I</td>
          <td>{{ trans['wheel_base'] }}</td>
          <td></td>
          <td><span class="size">1168</span><span class="mm">mm</span></td>
          <td><span class="size">1197</span><span class="mm">mm</span></td>
          <td><span class="size">1228</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('j') }"
          @mouseover="switchTable($event, 'j')"
        >
          <td>J</td>
          <td>{{ trans['head_tube_length'] }}</td>
          <td></td>
          <td><span class="size">100</span><span class="mm">mm</span></td>
          <td><span class="size">110</span><span class="mm">mm</span></td>
          <td><span class="size">125</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('k') }"
          @mouseover="switchTable($event, 'k')"
        >
          <td>K</td>
          <td>{{ trans['bb_height'] }}</td>
          <td></td>
          <td><span class="size">334</span><span class="mm">mm</span></td>
          <td><span class="size">334</span><span class="mm">mm</span></td>
          <td><span class="size">334</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('l') }"
          @mouseover="switchTable($event, 'l')"
        >
          <td>L</td>
          <td>{{ trans['fork_offset'] }}</td>
          <td></td>
          <td><span class="size">44</span><span class="mm">mm</span></td>
          <td><span class="size">44</span><span class="mm">mm</span></td>
          <td><span class="size">44</span><span class="mm">mm</span></td>
        </tr>
        </tbody>
      </table>
      <!-- cygnusEbike -->
      <table v-if="model==='cygnus' || model==='e-cygnus'" :class="sizeClass" cellpadding="0" cellspacing="0" class="geoTable">
        <thead>
        <tr>
          <th></th>
          <th></th>
          <th></th>
          <th>S/M</th>
          <th>L</th>
          <th>XL</th>
        </tr>
        </thead>
        <tbody>
        <tr
          :class="{ active: isLetterActive('a') }"
          @mouseover="switchTable($event, 'a')"
        >
          <td>A</td>
          <td>{{ trans['top_tube_horizontal'] }}</td>
          <td></td>
          <td><span class="size">595</span><span class="mm">mm</span></td>
          <td><span class="size">620</span><span class="mm">mm</span></td>
          <td><span class="size">650</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('b') }"
          @mouseover="switchTable($event, 'b')"
        >
          <td>B</td>
          <td>{{ trans['reach'] }}</td>
          <td></td>
          <td><span class="size">445</span><span class="mm">mm</span></td>
          <td><span class="size">470</span><span class="mm">mm</span></td>
          <td><span class="size">495</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('c') }"
          @mouseover="switchTable($event, 'c')"
        >
          <td>C</td>
          <td>{{ trans.stack }}</td>
          <td></td>
          <td><span class="size">602</span><span class="mm">mm</span></td>
          <td><span class="size">611</span><span class="mm">mm</span></td>
          <td><span class="size">625</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('d') }"
          @mouseover="switchTable($event, 'd')"
        >
          <td>D</td>
          <td>{{ trans['seat_tube_length'] }}</td>
          <td></td>
          <td><span class="size">415</span><span class="mm">mm</span></td>
          <td><span class="size">455</span><span class="mm">mm</span></td>
          <td><span class="size">500</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('e') }"
          @mouseover="switchTable($event, 'e')"
        >
          <td>E</td>
          <td>{{ trans['chainstay_horizontal'] }}</td>
          <td></td>
          <td><span class="size">448</span><span class="mm">mm</span></td>
          <td><span class="size">448</span><span class="mm">mm</span></td>
          <td><span class="size">448</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('f') }"
          @mouseover="switchTable($event, 'f')"
        >
          <td>F</td>
          <td>{{ trans['head_tube_angle'] }}</td>
          <td></td>
          <td>
            <span class="size">67 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">67 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">67 <sup>°</sup></span>
          </td>
        </tr>
        <tr
          :class="{ active: isLetterActive('g') }"
          @mouseover="switchTable($event, 'g')"
        >
          <td>G</td>
          <td>{{ trans['seat_tube_angle'] }}</td>
          <td></td>
          <td>
            <span class="size">76 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">76 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">75,5 <sup>°</sup></span>
          </td>
        </tr>
        <tr
          :class="{ active: isLetterActive('h') }"
          @mouseover="switchTable($event, 'h')"
        >
          <td>H</td>
          <td>{{ trans['bb_drop'] }}</td>
          <td></td>
          <td><span class="size">-36</span><span class="mm">mm</span></td>
          <td><span class="size">-36</span><span class="mm">mm</span></td>
          <td><span class="size">-36</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('i') }"
          @mouseover="switchTable($event, 'i')"
        >
          <td>I</td>
          <td>{{ trans['wheel_base'] }}</td>
          <td></td>
          <td><span class="size">1168</span><span class="mm">mm</span></td>
          <td><span class="size">1197</span><span class="mm">mm</span></td>
          <td><span class="size">1241</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('j') }"
          @mouseover="switchTable($event, 'j')"
        >
          <td>J</td>
          <td>{{ trans['head_tube_length'] }}</td>
          <td></td>
          <td><span class="size">100</span><span class="mm">mm</span></td>
          <td><span class="size">110</span><span class="mm">mm</span></td>
          <td><span class="size">125</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('k') }"
          @mouseover="switchTable($event, 'k')"
        >
          <td>K</td>
          <td>{{ trans['bb_height'] }}</td>
          <td></td>
          <td><span class="size">334</span><span class="mm">mm</span></td>
          <td><span class="size">334</span><span class="mm">mm</span></td>
          <td><span class="size">334</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('l') }"
          @mouseover="switchTable($event, 'l')"
        >
          <td>L</td>
          <td>{{ trans['fork_offset'] }}</td>
          <td></td>
          <td><span class="size">44</span><span class="mm">mm</span></td>
          <td><span class="size">44</span><span class="mm">mm</span></td>
          <td><span class="size">44</span><span class="mm">mm</span></td>
        </tr>
        </tbody>
      </table>
      <!-- siryonMusc -->
      <table v-if="model==='siryon.muscular'" :class="sizeClass" cellpadding="0" cellspacing="0" class="geoTable">
        <thead>
        <tr>
          <th></th>
          <th></th>
          <th></th>
          <th>S/M</th>
          <th>L</th>
          <th>XL</th>
        </tr>
        </thead>
        <tbody>
        <tr
          :class="{ active: isLetterActive('a') }"
          @mouseover="switchTable($event, 'a')"
        >
          <td>A</td>
          <td>{{ trans['top_tube_horizontal'] }}</td>
          <td></td>
          <td><span class="size">596</span><span class="mm">mm</span></td>
          <td><span class="size">642</span><span class="mm">mm</span></td>
          <td><span class="size">606</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('b') }"
          @mouseover="switchTable($event, 'b')"
        >
          <td>B</td>
          <td>{{ trans['reach'] }}</td>
          <td></td>
          <td><span class="size">458</span><span class="mm">mm</span></td>
          <td><span class="size">488</span><span class="mm">mm</span></td>
          <td><span class="size">508</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('c') }"
          @mouseover="switchTable($event, 'c')"
        >
          <td>C</td>
          <td>{{ trans.stack }}</td>
          <td></td>
          <td><span class="size">623</span><span class="mm">mm</span></td>
          <td><span class="size">638</span><span class="mm">mm</span></td>
          <td><span class="size">650</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('d') }"
          @mouseover="switchTable($event, 'd')"
        >
          <td>D</td>
          <td>{{ trans['seat_tube_length'] }}</td>
          <td></td>
          <td><span class="size">410</span><span class="mm">mm</span></td>
          <td><span class="size">440</span><span class="mm">mm</span></td>
          <td><span class="size">475</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('e') }"
          @mouseover="switchTable($event, 'e')"
        >
          <td>E</td>
          <td>{{ trans['chainstay_horizontal'] }}</td>
          <td></td>
          <td><span class="size">435</span><span class="mm">mm</span></td>
          <td><span class="size">445</span><span class="mm">mm</span></td>
          <td><span class="size">445</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('f') }"
          @mouseover="switchTable($event, 'f')"
        >
          <td>F</td>
          <td>{{ trans['head_tube_angle'] }}</td>
          <td></td>
          <td>
            <span class="size">64,5 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">64,5 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">64,5 <sup>°</sup></span>
          </td>
        </tr>
        <tr
          :class="{ active: isLetterActive('g') }"
          @mouseover="switchTable($event, 'g')"
        >
          <td>G</td>
          <td>{{ trans['seat_tube_angle'] }}</td>
          <td></td>
          <td>
            <span class="size">77,5 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">77,5 <sup>°</sup></span>
          </td>
          <td>
            <span class="size">75,5 <sup>°</sup></span>
          </td>
        </tr>
        <tr
          :class="{ active: isLetterActive('h') }"
          @mouseover="switchTable($event, 'h')"
        >
          <td>H</td>
          <td>{{ trans['bb_drop'] }}</td>
          <td></td>
          <td><span class="size">-25</span><span class="mm">mm</span></td>
          <td><span class="size">-25</span><span class="mm">mm</span></td>
          <td><span class="size">-25</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('i') }"
          @mouseover="switchTable($event, 'i')"
        >
          <td>I</td>
          <td>{{ trans['wheel_base'] }}</td>
          <td></td>
          <td><span class="size">1227</span><span class="mm">mm</span></td>
          <td><span class="size">1274</span><span class="mm">mm</span></td>
          <td><span class="size">1300</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('j') }"
          @mouseover="switchTable($event, 'j')"
        >
          <td>J</td>
          <td>{{ trans['head_tube_length'] }}</td>
          <td></td>
          <td><span class="size">95</span><span class="mm">mm</span></td>
          <td><span class="size">110</span><span class="mm">mm</span></td>
          <td><span class="size">125</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('k') }"
          @mouseover="switchTable($event, 'k')"
        >
          <td>K</td>
          <td>{{ trans['bb_height'] }}</td>
          <td></td>
          <td><span class="size">350</span><span class="mm">mm</span></td>
          <td><span class="size">350</span><span class="mm">mm</span></td>
          <td><span class="size">350</span><span class="mm">mm</span></td>
        </tr>
        <tr
          :class="{ active: isLetterActive('l') }"
          @mouseover="switchTable($event, 'l')"
        >
          <td>L</td>
          <td>{{ trans['fork_offset'] }}</td>
          <td></td>
          <td><span class="size">44</span><span class="mm">mm</span></td>
          <td><span class="size">44</span><span class="mm">mm</span></td>
          <td><span class="size">44</span><span class="mm">mm</span></td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ImageMap from "image-map";
import Siryon from "../../Parts/Geometry/Siryon";
import Cyon from "../../Parts/Geometry/Cyon";
import Aryon from "../../Parts/Geometry/Aryon";
import AryonSC from "../../Parts/Geometry/AryonSC";
import HydraHalo from "../../Parts/Geometry/HydraHalo";
import HydraDiode from "../../Parts/Geometry/HydraDiode";
import {mapGetters} from "vuex";
import CygnusMusc from "../../Parts/Geometry/CygnusMusc.vue";
import CygnusEbike from "../../Parts/Geometry/CygnusEbike.vue";
import SiryonMusc from "../../Parts/Geometry/SiryonMusc.vue";

export default {
  name: "GeometryTable",
  props: ['model', 'notSelectSize', 'trans'],
  components: {
    siryon: Siryon,
    cyon: Cyon,
    aryon: Aryon,
    aryonSC: AryonSC,
    hydraHalo: HydraHalo,
    hydraDiode: HydraDiode,
    cygnusMusc: CygnusMusc,
    cygnusEbike: CygnusEbike,
    siryonMusc: SiryonMusc,
  },
  data() {
    return {
      currentLetter: null,
      models: {
        siryon: {
          images: '/assets/images/builds/frame-siryon.jpg',
          items: [
            {
              cords: '245,13,14',
              shape: 'circle',
              letter: 'a'
            },
            {
              cords: '306,34,14',
              shape: 'circle',
              letter: 'b'
            },
            {
              cords: '274,231,15',
              shape: 'circle',
              letter: 'c'
            },
            {
              cords: '115,164,13',
              shape: 'circle',
              letter: 'd'
            },
            {
              cords: '116,286,14',
              shape: 'circle',
              letter: 'e'
            },
            {
              cords: '408,230,14',
              shape: 'circle',
              letter: 'f'
            },
            {
              cords: '159,226,12',
              shape: 'circle',
              letter: 'g'
            },
            {
              cords: '21,283,13',
              shape: 'circle',
              letter: 'h'
            },
            {
              cords: '225,305,14',
              shape: 'circle',
              letter: 'i'
            },
            {
              cords: '399,37,13',
              shape: 'circle',
              letter: 'j'
            },
            {
              cords: '338,281,12',
              shape: 'circle',
              letter: 'k'
            },
            {
              cords: '428,271,15',
              shape: 'circle',
              letter: 'l'
            },
          ]
        },
        cyon: {
          images: '/assets/images/builds/frame-cyon.jpg',
          items: [
            {
              cords: '245,17,10',
              shape: 'circle',
              letter: 'a'
            },
            {
              cords: '306,37,11',
              shape: 'circle',
              letter: 'b'
            },
            {
              cords: '273,235,10',
              shape: 'circle',
              letter: 'c'
            },
            {
              cords: '115,170,11',
              shape: 'circle',
              letter: 'd'
            },
            {
              cords: '116,290,11',
              shape: 'circle',
              letter: 'e'
            },
            {
              cords: '409,235,8',
              shape: 'circle',
              letter: 'f'
            },
            {
              cords: '159,232,8',
              shape: 'circle',
              letter: 'g'
            },
            {
              cords: '21,286,9',
              shape: 'circle',
              letter: 'h'
            },
            {
              cords: '223,309,11',
              shape: 'circle',
              letter: 'i'
            },
            {
              cords: '399,40,12',
              shape: 'circle',
              letter: 'j'
            },
            {
              cords: '338,286,11',
              shape: 'circle',
              letter: 'k'
            },
            {
              cords: '428,274,10',
              shape: 'circle',
              letter: 'l'
            },
          ]
        },
        aryon: {
          images: '/assets/images/builds/frame-aryon.jpg',
          items: [
            {
              cords: '244,9,11',
              shape: 'circle',
              letter: 'a'
            },
            {
              cords: '305,39,11',
              shape: 'circle',
              letter: 'b'
            },
            {
              cords: '273,194,13',
              shape: 'circle',
              letter: 'c'
            },
            {
              cords: '117,130,10',
              shape: 'circle',
              letter: 'd'
            },
            {
              cords: '117,250,9',
              shape: 'circle',
              letter: 'e'
            },
            {
              cords: '374,194,10',
              shape: 'circle',
              letter: 'f'
            },
            {
              cords: '159,191,10',
              shape: 'circle',
              letter: 'g'
            },
            {
              cords: '20,261,10',
              shape: 'circle',
              letter: 'h'
            },
            {
              cords: '223,269,10',
              shape: 'circle',
              letter: 'i'
            },
            {
              cords: '401,59,11',
              shape: 'circle',
              letter: 'j'
            },
            {
              cords: '339,248,10',
              shape: 'circle',
              letter: 'k'
            },
            {
              cords: '387,235,10',
              shape: 'circle',
              letter: 'l'
            },
          ]
        },
        'aryon-sc': {
          images: '/assets/images/builds/frame-aryon-sc.jpg',
          items: [
            {
              cords: '245,9,11',
              shape: 'circle',
              letter: 'a'
            },
            {
              cords: '305,39,11',
              shape: 'circle',
              letter: 'b'
            },
            {
              cords: '273,194,11',
              shape: 'circle',
              letter: 'c'
            },
            {
              cords: '116,129,10',
              shape: 'circle',
              letter: 'd'
            },
            {
              cords: '117,249,10',
              shape: 'circle',
              letter: 'e'
            },
            {
              cords: '374,194,11',
              shape: 'circle',
              letter: 'f'
            },
            {
              cords: '159,191,9',
              shape: 'circle',
              letter: 'g'
            },
            {
              cords: '21,261,11',
              shape: 'circle',
              letter: 'h'
            },
            {
              cords: '224,269,11',
              shape: 'circle',
              letter: 'i'
            },
            {
              cords: '401,59,9',
              shape: 'circle',
              letter: 'j'
            },
            {
              cords: '339,247,9',
              shape: 'circle',
              letter: 'k'
            },
            {
              cords: '389,234,10',
              shape: 'circle',
              letter: 'l'
            },
          ]
        },
        hydraHalo: {
          images: '/assets/images/builds/frame-hydra.jpg',
          items: [
            {
              cords: '248,16,11',
              shape: 'circle',
              letter: 'a'
            },
            {
              cords: '308,38,11',
              shape: 'circle',
              letter: 'b'
            },
            {
              cords: '274,232,11',
              shape: 'circle',
              letter: 'c'
            },
            {
              cords: '115,166,9',
              shape: 'circle',
              letter: 'd'
            },
            {
              cords: '116,287,10',
              shape: 'circle',
              letter: 'e'
            },
            {
              cords: '409,230,10',
              shape: 'circle',
              letter: 'f'
            },
            {
              cords: '159,228,8',
              shape: 'circle',
              letter: 'g'
            },
            {
              cords: '21,283,12',
              shape: 'circle',
              letter: 'h'
            },
            {
              cords: '224,306,11',
              shape: 'circle',
              letter: 'i'
            },
            {
              cords: '401,41,12',
              shape: 'circle',
              letter: 'j'
            },
            {
              cords: '339,283,9',
              shape: 'circle',
              letter: 'k'
            },
            {
              cords: '428,271,11',
              shape: 'circle',
              letter: 'l'
            },
          ]
        },
        hydraDiode: {
          images: '/assets/images/builds/frame-hydra.jpg',
          items: [
            {
              cords: '248,16,11',
              shape: 'circle',
              letter: 'a'
            },
            {
              cords: '308,38,11',
              shape: 'circle',
              letter: 'b'
            },
            {
              cords: '274,232,11',
              shape: 'circle',
              letter: 'c'
            },
            {
              cords: '115,166,9',
              shape: 'circle',
              letter: 'd'
            },
            {
              cords: '116,287,10',
              shape: 'circle',
              letter: 'e'
            },
            {
              cords: '409,230,10',
              shape: 'circle',
              letter: 'f'
            },
            {
              cords: '159,228,8',
              shape: 'circle',
              letter: 'g'
            },
            {
              cords: '21,283,12',
              shape: 'circle',
              letter: 'h'
            },
            {
              cords: '224,306,11',
              shape: 'circle',
              letter: 'i'
            },
            {
              cords: '401,41,12',
              shape: 'circle',
              letter: 'j'
            },
            {
              cords: '339,283,9',
              shape: 'circle',
              letter: 'k'
            },
            {
              cords: '428,271,11',
              shape: 'circle',
              letter: 'l'
            },
          ]
        },
        "cygnus.muscular": {
          images: '/assets/images/builds/cygnus-1.jpg',
          items: [
            {
              cords: '286,13,12',
              shape: 'circle',
              letter: 'a'
            },
            {
              cords: '325,35,12',
              shape: 'circle',
              letter: 'b'
            },
            {
              cords: '363,226,12',
              shape: 'circle',
              letter: 'c'
            },
            {
              cords: '140,177,11',
              shape: 'circle',
              letter: 'd'
            },
            {
              cords: '128,335,12',
              shape: 'circle',
              letter: 'e'
            },
            {
              cords: '447,246,11',
              shape: 'circle',
              letter: 'f'
            },
            {
              cords: '192,70,11',
              shape: 'circle',
              letter: 'g'
            },
            {
              cords: '12,337,11',
              shape: 'circle',
              letter: 'h'
            },
            {
              cords: '369,355,12',
              shape: 'circle',
              letter: 'i'
            },
            {
              cords: '460,52,11',
              shape: 'circle',
              letter: 'j'
            },
            {
              cords: '301,332,12',
              shape: 'circle',
              letter: 'k'
            },
            {
              cords: '533,325,12',
              shape: 'circle',
              letter: 'l'
            },
          ]
        },
        cygnus: {
          images: '/assets/images/builds/cygnus-2.jpg',
          items: [
            {
              cords: '290,13,12',
              shape: 'circle',
              letter: 'a'
            },
            {
              cords: '321,35,11',
              shape: 'circle',
              letter: 'b'
            },
            {
              cords: '368,235,13',
              shape: 'circle',
              letter: 'c'
            },
            {
              cords: '125,185,13',
              shape: 'circle',
              letter: 'd'
            },
            {
              cords: '134,360,11',
              shape: 'circle',
              letter: 'e'
            },
            {
              cords: '446,256,12',
              shape: 'circle',
              letter: 'f'
            },
            {
              cords: '191,79,12',
              shape: 'circle',
              letter: 'g'
            },
            {
              cords: '12,336,11',
              shape: 'circle',
              letter: 'h'
            },
            {
              cords: '371,379,12',
              shape: 'circle',
              letter: 'i'
            },
            {
              cords: '454,64,12',
              shape: 'circle',
              letter: 'j'
            },
            {
              cords: '302,346,13',
              shape: 'circle',
              letter: 'k'
            },
            {
              cords: '532,342,12',
              shape: 'circle',
              letter: 'l'
            },
          ]
        },
        "siryon.muscular": {
          images: '/assets/images/builds/frame-siryon-musc.jpg',
          items: [
            {
              cords: '284,12,11',
              shape: 'circle',
              letter: 'a'
            },
            {
              cords: '319,34,11',
              shape: 'circle',
              letter: 'b'
            },
            {
              cords: '379,218,11',
              shape: 'circle',
              letter: 'c'
            },
            {
              cords: '137,171,12',
              shape: 'circle',
              letter: 'd'
            },
            {
              cords: '132,328,11',
              shape: 'circle',
              letter: 'e'
            },
            {
              cords: '452,241,12',
              shape: 'circle',
              letter: 'f'
            },
            {
              cords: '196,72,11',
              shape: 'circle',
              letter: 'g'
            },
            {
              cords: '12,327,11',
              shape: 'circle',
              letter: 'h'
            },
            {
              cords: '357,349,11',
              shape: 'circle',
              letter: 'i'
            },
            {
              cords: '459,59,11',
              shape: 'circle',
              letter: 'j'
            },
            {
              cords: '295,326,11',
              shape: 'circle',
              letter: 'k'
            },
            {
              cords: '531,322,11',
              shape: 'circle',
              letter: 'l'
            },
          ]
        },
      },
      size: 's'
    }
  },
  computed: {
    ...mapGetters({
      'selectedSize': 'build/selectedSize'
    }),
    sizeClass() {
      return {
        's-bold': this.size === 's',
        'm-bold': this.size === 'm',
        'l-bold': this.size === 'l',
        'xl-bold': this.size === 'xl',
      }
    },
  },
  mounted() {
    console.log("Model Slug", this.model)
    ImageMap('img[usemap]')
    this.widthFl()
    window.addEventListener('resize', this.widthFl)
    if (!this.notSelectSize) {
      this.$root.$on('sizeChanged', () => {
        let sizeTitle = 's'
        switch (this.selectedSize.title) {
          case this.trans['extra_large']:
            sizeTitle = 'xl';
            break;
          case this.trans['large']:
            sizeTitle = 'l';
            break;
          case this.trans['medium']:
            sizeTitle = 'm';
            break;
          case this.trans['small']:
            sizeTitle = 's';
            break;
        }
        this.size = sizeTitle
      })
    } else {
      this.size = null
    }
  },
  methods: {
    // переключение таблицы
    switchTable(event, letter) {
      this.currentLetter = letter
    },
    isLetterActive(letter) {
      return this.currentLetter === letter
    },

    // получаю ширину body и передаю ее #fixLine
    widthFl: function () {
      let bodyWidth = document.body.clientWidth
      let fixLine = document.getElementById('fixLine')
      if (fixLine) {
        fixLine.style.width = bodyWidth + 'px'
      }
    },
  },
}
</script>

<style lang="scss">
.geo-table-wrap {
  position: relative;

  &.aryon,
  &.aryonSC {
    .geometryWrap {
      img, svg {
        @media (min-width: 768px) {
          max-width: 540px !important;
          margin-left: auto;
          margin-right: auto;
        }
      }
    }
  }

  .flex {
    display: flex;
    align-items: center;
  }

  .geometryWrap {
    width: calc(55% - 40px);
    margin-right: 40px;
    margin-top: 40px;
    position: relative;
    z-index: 1;

    img {
      width: 100%;
      max-width: 100%;
      opacity: 0;
      //margin: auto;
      display: block;
    }

    svg {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      //margin: auto;
      z-index: -1;
      max-width: 100%;
      max-height: 100%;

      path, line, rect {
        transition: 0.6s;
      }

      path.active, line.active, rect.active {
        opacity: 1;
        z-index: 10;
        position: relative;

        &[fill] {
          fill: #c2e900;
        }

        &[stroke] {
          stroke: #c2e900;
        }
      }
    }
  }

  .geoTable {
    width: 45%;
  }

  @media (max-width: 1300px) {
    .geometryWrap {
      width: calc(50% - 40px);
    }
    .geoTable {
      width: 50%;
    }
  }
  @media (max-width: 991px) {
    .flex {
      flex-wrap: wrap;
    }

    .geometryWrap {
      width: 100%;
      margin: 0 auto 40px;
      max-width: 626px;
    }

    .geoTable {
      width: 100%;
    }
  }
  @media (max-width: 768px) {
    .geometryWrap {
      margin: 0 auto 30px;

    }
  }
}

.geoTable {
  border: none;

  thead {
    tr {
      border: none;

      th {
        font-weight: bold;
        font-size: 14px;
        line-height: 14px;
        padding: 13px 0;
        color: #000;
        border: none;
        text-align: left;
        &:nth-child(3):last-child{
          // размер последней ячейки у арионов
          width: 100px;
        }
      }
    }
  }

  tbody {
    tr {
      border: none;
      cursor: pointer;
      transition: 0.4s;

      td {
        padding: 16px 2px;
        border: none;
        box-sizing: border-box;
        font-weight: normal;
        font-size: 14px;
        line-height: 14px;
        color: #515151;
        &:nth-child(3):last-child{
          // размер последней ячейки у арионов
          width: 100px;
        }
        &:first-child {
          font-weight: bold;
          line-height: 12px;
          color: #000;
          text-align: center;
          width: 40px;
          border-left: 6px solid transparent;
          border-top-left-radius: 6px;
          border-bottom-left-radius: 6px;
        }

        &:nth-child(2) {
          width: 170px;
        }

        .size {
          color: #000;
          margin-right: 4px;
        }

        .mm {
          color: #a3a3a3;
        }

        sup {
          font-size: 16px;
          line-height: 1px;
          top: 0;
        }
      }

      &.active {
        background: #f8f8f8;
        border-radius: 7px;

        td:first-child {
          border-color: #c2e900;
        }

        td {
          font-weight: 600;
          letter-spacing: -0.1px;
          color: #000;

          span {
            font-weight: 600;
            letter-spacing: -0.1px;

            &.size,
            &.mm {
              color: #000;
            }
          }
        }
      }
    }
  }

  &.s-bold {
    tbody tr td:nth-child(3) {
      font-weight: 600;
    }
  }

  &.m-bold {
    tbody tr td:nth-child(4) {
      font-weight: 600;
    }
  }

  &.l-bold {
    tbody tr td:nth-child(5) {
      font-weight: 600;
    }
  }

  &.xl-bold {
    tbody tr td:nth-child(6) {
      font-weight: 600;
    }
  }

  @media (max-width: 991px) {
    tbody tr {
      border-bottom: 6px solid transparent;

      td {
        padding: 12px 2px;
      }
    }
  }
  @media (max-width: 575px) {
    width: calc(100% + 40px);
    margin-left: -20px;
    min-width: calc(100% + 40px);
    thead {
      tr {
        th {
          font-size: 12px;
          line-height: 12px;
          padding: 10px 0;
        }
      }
    }
    tbody {
      tr {
        border-radius: 0;

        td {
          padding: 12px 2px;
          border-radius: 0;
          font-size: 11px;
          line-height: 10px;
          &:first-child {
            font-weight: bold;
            line-height: 12px;
            border-radius: 0;
          }

          &:nth-child(2) {
            width: 130px;
          }



          .mm {
            font-size: 9px;
          }

          sup {
            font-size: 14px;
          }
        }

        &.active {
          border-radius: 0;
        }
      }
    }
  }
}
</style>
